import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaSpinner, FaUser, FaHeart, FaPlay, FaArrowRight, FaArrowLeft, FaChevronUp, FaChevronDown, FaNewspaper, FaEllipsisV, FaEye, FaQuestionCircle } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import timezones from 'timezones-list';

const Historique_unifie = ({ titre }) => {
    useAuth();

    // États communs
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortConfig, setSortConfig] = useState({ key: 'date_unifiee', direction: 'descending' });
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [showColumnSelector, setShowColumnSelector] = useState(false);

    // NOUVEAU : États pour les spécialités de l'utilisateur
    const [userSpecialites, setUserSpecialites] = useState([]);
    const [activeSpecialite, setActiveSpecialite] = useState(null);
    const [isLoadingUserSpecialites, setIsLoadingUserSpecialites] = useState(false);

    // États pour les colonnes visibles
    const [visibleColumns, setVisibleColumns] = useState({
        date_unifiee: true,
        specialite: true,
        domaine_titre: false,
        processus_titre: false,
        qcmNumber: true,
        langue: true,
        niveau: false,
        resultat: true,
        tags: true,
        ref: false,
        type_examen: false,
        nbre_heures: false,
        statut: true,
        motif: false
    });

    // États pour les simulations
    const [allData, setAllData] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [domainesFr, setDomainesFr] = useState([]);
    const [groupeProcessusFr, setGroupeProcessusFr] = useState([]);
    const [showSimulationModal, setShowSimulationModal] = useState(false);
    const [isLoadingLancement, setIsLoadingLancement] = useState(false);
    const [isLoadingPrincipe, setIsLoadingPrincipe] = useState(false);
    const [isLoadingEnreg, setIsLoadingEnreg] = useState(false);

    // États pour les examens
    const [showExamenModal, setShowExamenModal] = useState(false);
    const [showEssaiModal, setShowEssaiModal] = useState(false);
    const [showModifierModal, setShowModifierModal] = useState(false);
    const [showDemarageModal, setShowDemarageModal] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [pauseChoice, setPauseChoice] = useState("avecPause");

    // Formulaires
    const [newSimulation, setNewSimulation] = useState({
        domaine: '',
        processus: '',
        langue: '',
        niveau: '',
        qcmNumber: '',
        agile: false,
        nonTraite: false,
        aleatoire: false,
    });

    const [newExamenblanc, setNewExamenblanc] = useState({
        date: '',
        heure_examen: '',
        date_examen: '',
        tag: '',
        type_examen: '',
        langue: '',
        nbre_heures: '',
        non_traite: false,
        code_essai: '',
        plage_debut: '',
        plage_fin: ''
    });

    const [examenblancDetails, setExamenblancDetails] = useState({
        date: '',
        heure_examen: '',
        date_examen: '',
        tag: '',
        type_examen: '',
        langue: '',
        nbre_heures: '',
        non_traite: false,
        code_essai: '',
        plage_debut: '',
        plage_fin: ''
    });

    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();
    const examen_id_strored = localStorage.getItem('examen_id_strored');
    const stored = localStorage.getItem('heureFinExamen');

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Simulateur";
        }
    }, [user_id]);

    useEffect(() => {
        fetchAllData();
    }, []);

    // Chargement des spécialités de l'utilisateur
    useEffect(() => {
        if (user_id) {
            fetchUserSpecialites();
        }
    }, [user_id]);

    // Recharger les données quand la spécialité active change
    useEffect(() => {
        if (activeSpecialite && user_id) {
            fetchHistoriqueUnifie();
        }
    }, [activeSpecialite]);

    const fetchAllData = async () => {
        setIsLoading(true);
        try {
            await Promise.all([
                fetchHistoriqueUnifie(),
                fetchDomaines(),
                fetchGroupeProcessus()
            ]);
        } catch (error) {
            console.error('Erreur lors du chargement des données:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Fonction pour récupérer les spécialités de l'utilisateur connecté
    const fetchUserSpecialites = async () => {
        setIsLoadingUserSpecialites(true);
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                const specialites = data.specialites || [];
                setUserSpecialites(specialites);
                if (specialites.length > 0) {
                    setActiveSpecialite(specialites[0]);
                }
                console.log("Spécialités utilisateur:", specialites);
            } else {
                console.error('Erreur lors de la récupération des spécialités utilisateur');
                setUserSpecialites([]);
            }
        } catch (error) {
            console.error('Erreur réseau spécialités:', error);
            setUserSpecialites([]);
        } finally {
            setIsLoadingUserSpecialites(false);
        }
    };

    const fetchHistoriqueUnifie = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/historique-unifie/${user_id}/`);
            if (response.ok) {
                const data = await response.json();
                setAllData(data);
            } else {
                console.error('Erreur lors de la récupération de l\'historique unifié');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchDomaines = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/Liste-domaine/');
            if (response.ok) {
                const data = await response.json();
                setDomainesFr(data);
            } else {
                console.error('Erreur lors de la récupération des domaines');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchGroupeProcessus = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/listes-groupes-processus/');
            if (response.ok) {
                const data = await response.json();
                setGroupeProcessusFr(data);
            } else {
                console.error('Erreur lors de la récupération des groupes processus');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const handleNewSimulationChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewSimulation((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmitNewSimulation = async () => {
        setIsLoadingEnreg(true);

        // Validation adaptée à la spécialité
        const needsProcessus = !isActivePMICPNoProcessus();
        if (!newSimulation.domaine || !newSimulation.langue ||
            (needsProcessus && !newSimulation.processus) ||
            !newSimulation.niveau || !newSimulation.qcmNumber) {
            showAlert("Veuillez remplir tous les champs obligatoires.", "danger");
            setIsLoadingEnreg(false);
            return;
        }

        // Vérifier que la spécialité a bien des domaines associés
        if (getDomainesForActiveSpecialite().length === 0) {
            showAlert("Aucun domaine n'est associé à cette spécialité.", "danger");
            setIsLoadingEnreg(false);
            return;
        }

        try {
            // Pour PMI-CP, on force processus à "tout"
            const payload = {
                ...newSimulation,
                processus: needsProcessus ? newSimulation.processus : "0",
                specialite_id: activeSpecialite?.id,
            };

            const response = await fetch(process.env.REACT_APP_HOTE + `/enreg-simulation/${user_id}/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await response.json();
            if (response.ok) {
                setShowSimulationModal(false);
                showAlert("Simulation enregistrée avec succès !");
                setNewSimulation({
                    domaine: '', processus: '', langue: '', niveau: '',
                    qcmNumber: '', agile: false, nonTraite: false, aleatoire: false
                });
                fetchHistoriqueUnifie();
            } else {
                showAlertModal(data.error, 'danger');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showAlert("Problème de connexion, veuillez reéssayer !", "danger");
        } finally {
            setIsLoadingEnreg(false);
        }
    };

    const handleDemarrerSimulation = async (simulation) => {
        setIsLoadingLancement(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/demarrer-simulation/${user_id}/${simulation.id}/`);
            if (response.ok) {
                navigate(`/Demarrer`, { state: { simulation_id: simulation.id } });
            } else {
                showAlert('Cette simulation ne respecte pas les conditions requises.', 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingLancement(false);
        }
    };

    // const handleChargerPrincipe = async (simulation) => {
    //     setIsLoadingPrincipe(true);
    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_HOTE}/charger-qcms-principe/${user_id}/`);
    //         const data = await response.json();
    //         if (response.ok) {
    //             navigate(`/Resultats-principe`);
    //         } else {
    //             showAlert(data.error, 'danger');
    //         }
    //     } catch (error) {
    //         console.error('Erreur réseau:', error);
    //     } finally {
    //         setIsLoadingPrincipe(false);
    //     }
    // };

    const handleChargerPrincipe = async () => {
        if (!activeSpecialite) {
            showAlert("Aucune spécialité active.", "danger");
            return;
        }

        setIsLoadingPrincipe(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/charger-qcms-principe/${user_id}/`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        specialite_id: activeSpecialite.id
                    }),
                }
            );

            const data = await response.json();
            if (response.ok) {
                // ⬇ AJOUT : passer specialite_id dans le state
                navigate(`/Resultats-principe`, {
                    state: {
                        specialite_id: activeSpecialite.id,
                        specialite_titre: activeSpecialite.titre
                    }
                });
            } else {
                showAlert(data.error, 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Erreur de connexion.", "danger");
        } finally {
            setIsLoadingPrincipe(false);
        }
    };

    const handleShowModifierModal = async (examenItem) => {
        if (examenItem && user_id) {
            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-examenblanc/${examenItem.id}/${user_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setExamenblancDetails({
                        date_examen: data.date_examen.split('T')[0],
                        heure_examen: data.date_examen.split('T')[1]?.substring(0, 5) || '00:00',
                        type_examen: data.type_examen,
                        langue: data.langue,
                        nbre_heures: data.nbre_heures,
                        non_traite: data.non_traite,
                        timezone: data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
                    });
                    setSelectedItem(data);
                    setShowModifierModal(true);
                } else {
                    console.error("Erreur lors de la récupération des données de l'examen blanc");
                }
            } catch (error) {
                console.error("Erreur lors de la requête :", error);
            }
        }
    };

    const fetchExamenblancDetails = async (id, user_id) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-examenblanc/${id}/${user_id}/`);
            if (response.ok) {
                const data = await response.json();
                setExamenblancDetails({
                    date_examen: data.date_examen.split('T')[0],
                    heure_examen: data.date_examen.split('T')[1]?.substring(0, 5) || '00:00',
                    type_examen: data.type_examen,
                    langue: data.langue,
                    nbre_heures: data.nbre_heures,
                    non_traite: data.non_traite,
                    timezone: data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
                });
                setSelectedItem(data);
                setShowModifierModal(true);
            } else {
                console.error("Erreur lors de la récupération des données de l'examen blanc");
            }
        } catch (error) {
            console.error("Erreur lors de la requête :", error);
        }
    };

    const handleModifierExamen = async () => {
        setIsButtonLoading(true)
        if (selectedItem && user_id) {
            if (!examenblancDetails.date_examen) {
                showAlertModal("Veuillez renseigner la date de l'examen !", 'danger');
                setIsButtonLoading(false);
                return;
            }
            if (!examenblancDetails.heure_examen) {
                showAlertModal("Veuillez renseigner l'heure de l'examen !", 'danger');
                setIsButtonLoading(false);
                return;
            }
            if (!examenblancDetails.type_examen) {
                showAlertModal("Veuillez renseigner le type d'examen !", 'danger');
                setIsButtonLoading(false);
                return;
            }
            if (!examenblancDetails.langue) {
                showAlertModal("Veuillez renseigner la langue de l'examen !", 'danger');
                setIsButtonLoading(false);
                return;
            }
            if (!examenblancDetails.nbre_heures) {
                showAlertModal("Veuillez indiquer le nombre d'heures !", 'danger');
                setIsButtonLoading(false);
                return;
            }

            const selectedTimezone = examenblancDetails.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
            const dateTimeString = `${examenblancDetails.date_examen}T${examenblancDetails.heure_examen}`;
            const examDateLocal = new Date(dateTimeString);
            const examDateUTC = new Date(examDateLocal.getTime() - examDateLocal.getTimezoneOffset() * 60000);

            console.log(`Date sélectionnée (${selectedTimezone}) :`, examDateLocal);
            console.log(`Date convertie en UTC :`, examDateUTC);

            const examenData = {
                dateTime_examen: examDateUTC.toISOString(),
                date_examen: examenblancDetails.date_examen,
                heure_examen: examenblancDetails.heure_examen,
                type_examen: examenblancDetails.type_examen,
                langue: examenblancDetails.langue,
                nbre_heures: examenblancDetails.nbre_heures,
                non_traite: examenblancDetails.non_traite,
                timezone: selectedTimezone
            };

            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-examenblanc/${selectedItem?.id}/${user_id}/`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(examenData)
                });

                if (response.ok) {
                    console.log("Examen blanc mis à jour avec succès");
                    setShowModifierModal(false);
                    showAlert("Examen blanc modifié avec succès !");
                    fetchHistoriqueUnifie();
                } else {
                    const errorData = await response.json();
                    console.error('Erreur du serveur:', errorData);
                    showAlertModal('Erreur lors de la modification de l\'examen blanc : ' + (errorData.error || 'Erreur inconnue.'), 'danger');
                }
            } catch (error) {
                console.error("Erreur lors de la requête :", error);
                showAlertModal("Une erreur est survenue lors de la modification !", "danger");
            } finally {
                setIsButtonLoading(false)
            }
        } else {
            console.error("Identifiant d'examen ou identifiant d'utilisateur manquant");
            showAlertModal("Identifiant d'examen ou identifiant d'utilisateur manquant", "danger");
            setIsButtonLoading(false)
        }
    };

    const handleNewExamenblancChange = (e) => {
        const { name, value } = e.target;
        setNewExamenblanc((prev) => {
            let updatedExamen = { ...prev, [name]: value };
            if (name === "date_examen" || name === "heure_examen") {
                const date = updatedExamen.date_examen || new Date().toISOString().split("T")[0];
                const time = updatedExamen.heure_examen || "00:00";
                updatedExamen["dateTime_examen"] = `${date}T${time}`;
            }
            return updatedExamen;
        });
    };

    const handleSubmitNewExamenblanc = async () => {
        if (newExamenblanc.type_examen === 'Bootcamp' && !newExamenblanc.tag) {
            showAlert("Veuillez renseigner le tag du bootcamp !", 'danger');
            return;
        }
        if (newExamenblanc.type_examen !== 'Bootcamp') {
            if (!newExamenblanc.date_examen || !newExamenblanc.heure_examen || !newExamenblanc.type_examen ||
                !newExamenblanc.langue || !newExamenblanc.nbre_heures) {
                showAlert("Veuillez remplir tous les champs obligatoires !", 'danger');
                return;
            }
        }

        setIsButtonLoading(true);
        try {
            let dateTimeExamen;
            if (newExamenblanc.type_examen === 'Bootcamp') {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');
                dateTimeExamen = `${year}-${month}-${day}T${hours}:${minutes}:00`;
            } else {
                dateTimeExamen = `${newExamenblanc.date_examen}T${newExamenblanc.heure_examen}:00`;
            }

            const examenData = {
                ...newExamenblanc,
                date_examen: dateTimeExamen,
                timezone: newExamenblanc.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
                specialite_id: activeSpecialite?.id,
                ...(newExamenblanc.type_examen === 'Bootcamp' && {
                    langue: 'Fr', nbre_heures: '1'
                })
            };

            const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-examenblanc/${user_id}/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(examenData),
            });

            if (response.ok) {
                setShowExamenModal(false);
                showAlert("Examen enregistré avec succès !");
                setNewExamenblanc({
                    date_examen: '', heure_examen: '', type_examen: '', langue: '',
                    nbre_heures: '', non_traite: false, tag: ''
                });
                fetchHistoriqueUnifie();
            } else {
                const errorData = await response.json();
                showAlertModal(errorData.error || 'Erreur inconnue.', 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Une erreur est survenue lors de l'enregistrement !", "danger");
        } finally {
            setIsButtonLoading(false);
        }
    };

    const handleSubmitEssai = async () => {
        if (!newExamenblanc.code_essai || !newExamenblanc.langue) {
            showAlert("Veuillez renseigner le code et la langue de l'essai !", 'danger');
            return;
        }

        setIsButtonLoading(true);
        try {
            const essaiData = {
                type_examen: 'Essai',
                code_essai: newExamenblanc.code_essai,
                langue: newExamenblanc.langue,
                plage_debut: newExamenblanc.plage_debut,
                plage_fin: newExamenblanc.plage_fin,
                timezone: newExamenblanc.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
                specialite_id: activeSpecialite?.id,
            };

            const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-essai/${user_id}/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(essaiData),
            });

            if (response.ok) {
                setShowEssaiModal(false);
                showAlert("Essai enregistré avec succès !");
                setNewExamenblanc({
                    type_examen: '', langue: '', non_traite: false, code_essai: '', plage_debut: '', plage_fin: ''
                });
                fetchHistoriqueUnifie();
            } else {
                const errorData = await response.json();
                showAlertModal(errorData.error || 'Erreur inconnue.', 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Une erreur est survenue lors de l'enregistrement !", "danger");
        } finally {
            setIsButtonLoading(false);
        }
    };

    const handleDemarrerExamen = (examenItem) => {
        if (examenItem) {
            navigate(`/Lancement-examen`, {
                state: {
                    examen_id: examenItem.id,
                    nbre_heures: examenItem.nbre_heures,
                    statut: examenItem.statut,
                    pauseChoice: pauseChoice,
                    type_examen: examenItem.type_examen
                },
            });
        }
    };

    const handleResultatSimulateur = (simulation_id) => {
        if (simulation_id) {
            navigate(`/Terminer`, {
                state: { simulation_id: simulation_id },
            });
        }
    };

    const handleResultatExamen = (examen_id) => {
        if (examen_id) {
            navigate(`/Fin-examen`, {
                state: { examen_id: examen_id, user_id: user_id },
            });
        }
    };

    const handleRecommencerEssai = async (examenItem) => {
        if (examenItem && examenItem.type_examen === 'Essai') {
            setIsLoadingLancement(true);
            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/recommencer-essai/${examenItem.id}/${user_id}/`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data.success) {
                        showAlert("Essai réinitialisé avec succès !");
                        navigate(`/Lancement-examen`, {
                            state: {
                                examen_id: examenItem.id,
                                nbre_heures: examenItem.nbre_heures,
                                statut: "Approuve",
                                pauseChoice: "sansPause",
                                type_examen: examenItem.type_examen
                            },
                        });
                    } else {
                        showAlert(data.error || "Erreur lors de la réinitialisation de l'essai", "danger");
                    }
                } else {
                    const errorData = await response.json();
                    showAlert(errorData.error || "Erreur lors de la réinitialisation de l'essai", "danger");
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert("Une erreur est survenue lors de la réinitialisation de l'essai", "danger");
            } finally {
                setIsLoadingLancement(false);
            }
        }
    };

    const isDatePassedOrEqualNow = (dateString) => {
        try {
            const [datePart, timePart] = dateString.trim().split(' ');
            const [day, month, year] = datePart.split('/').map(Number);
            const [hours, minutes] = timePart.split(':').map(Number);
            const examDate = new Date(year, month - 1, day, hours, minutes);
            const now = new Date();
            return now >= examDate;
        } catch (error) {
            console.error("Erreur dans la comparaison :", error);
            return false;
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
        setAlertModal({ message: '', type: '' });
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const formatValue = (value) => {
        if (value === null || value === undefined || value === '' || value === ' ') {
            return '-';
        }
        return value;
    };

    const getResultatUnifie = (item) => {
        if (item.type === 'simulation') {
            return item.pourcentage ? `${item.pourcentage}%` : '-';
        } else {
            if (item.total_questions && item.nombre_correct && item.pourcent) {
                return `${item.nombre_correct}/${item.total_questions} (${item.pourcent}%)`;
            }
            return '-';
        }
    };

    const parseDate = (dateString) => {
        if (!dateString) return new Date(0);
        try {
            const cleanedString = dateString.trim();
            const [datePart, timePart] = cleanedString.split(' ');
            if (datePart && timePart) {
                const [day, month, year] = datePart.split('/').map(Number);
                const [hours, minutes] = timePart.split(':').map(Number);
                return new Date(year, month - 1, day, hours, minutes);
            }
        } catch (error) {
            console.error("Erreur lors du parsing de la date:", error, dateString);
        }
        return new Date(0);
    };

    // Fonctions utilitaires pour les spécialités
    const isActiveSpecialite = (spec) => {
        if (!activeSpecialite || !spec) return false;
        return activeSpecialite.id === spec.id;
    };

    const activeSpecialiteHas = (keyword) => {
        if (!activeSpecialite || !activeSpecialite.titre) return false;
        return activeSpecialite.titre.toLowerCase().includes(keyword.toLowerCase());
    };

    const isActivePMP = () => activeSpecialiteHas('pmp');
    const isActivePMICP = () => activeSpecialiteHas('pmi-cp') || activeSpecialiteHas('pmi cp') || activeSpecialiteHas('pmicp');
    const isActiveCAPM = () => activeSpecialiteHas('capm');

    const isMindsetQCMAvailable = () => isActivePMP();
    const isSimulationAvailable = () => isActivePMP();

    const getAvailableExamTypes = () => {
        if (isActivePMP()) return ['PMP', 'CAPM'];
        if (isActivePMICP()) return ['PMI-CP'];
        if (isActiveCAPM()) return ['CAPM'];
        return ['PMP', 'CAPM', 'PMI-CP'];
    };

    const filterDataByActiveSpecialite = (data) => {
        if (!activeSpecialite) return data;
        return data.filter(item => {
            if (item.specialite_id) {
                return item.specialite_id === activeSpecialite.id;
            }
            return true;
        });
    };

    // Récupère les domaines liés à la spécialité active
    const getDomainesForActiveSpecialite = () => {
        if (!activeSpecialite || !activeSpecialite.domaine || activeSpecialite.domaine.length === 0) {
            return []; // Aucun domaine associé -> liste vide
        }
        return domainesFr.filter(d => activeSpecialite.domaine.includes(d.titre));
    };

    // Détecte si la spécialité active est PMI-CP (pas de processus)
    const isActivePMICPNoProcessus = () => isActivePMICP();

    // Filtrage et tri des données
    const filteredData = filterDataByActiveSpecialite(allData).filter(item =>
        item.type === 'simulation'
            ? ((item.date_unifiee && item.date_unifiee.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.domaine_titre && item.domaine_titre.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.processus_titre && item.processus_titre.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.qcmNumber && item.qcmNumber.toString().includes(searchTerm)) ||
                (item.tags && item.tags.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.niveau && item.niveau.toString().includes(searchTerm)) ||
                (item.langue && item.langue.toLowerCase().includes(searchTerm)) ||
                (item.resultat && item.resultat.toLowerCase().includes(searchTerm.toLowerCase())))
            : ((item.date_unifiee && item.date_unifiee.toString().includes(searchTerm.toLowerCase())) ||
                (item.type_examen && item.type_examen?.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.tag && item.tag?.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.langue && item.langue?.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.nbre_heures && item.nbre_heures.toString().includes(searchTerm)) ||
                (item.non_traite !== undefined && item.non_traite.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.statut && item.statut?.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.motif && item.motif?.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.resultat && item.resultat.toLowerCase().includes(searchTerm.toLowerCase())))
    );

    const sortedData = [...filteredData].sort((a, b) => {
        const direction = sortConfig.direction === 'descending' ? -1 : 1;

        // Tri par date (timestamp)
        if (sortConfig.key === 'date_unifiee') {
            if (a.date_timestamp < b.date_timestamp) return sortConfig.direction === 'descending' ? 1 : -1;
            if (a.date_timestamp > b.date_timestamp) return sortConfig.direction === 'descending' ? -1 : 1;
            return 0;
        }

        // Tri par Type
        if (sortConfig.key === 'type') {
            const getTypeLabel = (item) => {
                if (item.type === 'simulation') return 'Simulation';
                if (item.type_examen === 'Essai') return 'Essai';
                return 'Examen';
            };
            const typeA = getTypeLabel(a).toLowerCase();
            const typeB = getTypeLabel(b).toLowerCase();
            if (typeA < typeB) return -1 * direction;
            if (typeA > typeB) return 1 * direction;
            return 0;
        }

        // Tri par Spécialité
        if (sortConfig.key === 'specialite_titre') {
            const specA = (a.specialite_titre || 'zzz').toLowerCase();
            const specB = (b.specialite_titre || 'zzz').toLowerCase();
            if (specA < specB) return -1 * direction;
            if (specA > specB) return 1 * direction;
            return 0;
        }

        // Tri par Nbre questions
        if (sortConfig.key === 'qcmNumber') {
            const numA = parseInt(a.qcmNumber || a.total_questions || 0);
            const numB = parseInt(b.qcmNumber || b.total_questions || 0);
            return (numA - numB) * direction;
        }

        // Tri par Langue
        if (sortConfig.key === 'langue') {
            const langA = (a.langue || '').toLowerCase();
            const langB = (b.langue || '').toLowerCase();
            if (langA < langB) return -1 * direction;
            if (langA > langB) return 1 * direction;
            return 0;
        }

        // Tri par Statut
        if (sortConfig.key === 'statut') {
            const statA = (a.statut || '').toLowerCase();
            const statB = (b.statut || '').toLowerCase();
            if (statA < statB) return -1 * direction;
            if (statA > statB) return 1 * direction;
            return 0;
        }

        // Tri par Résultat
        if (sortConfig.key === 'resultat') {
            const resA = (a.resultat || '').toLowerCase();
            const resB = (b.resultat || '').toLowerCase();
            if (resA < resB) return -1 * direction;
            if (resA > resB) return 1 * direction;
            return 0;
        }

        // Tri par Tags
        if (sortConfig.key === 'tags') {
            const tagA = (a.tags || a.tag || '').toLowerCase();
            const tagB = (b.tags || b.tag || '').toLowerCase();
            if (tagA < tagB) return -1 * direction;
            if (tagA > tagB) return 1 * direction;
            return 0;
        }

        // Tri par Ref (id)
        if (sortConfig.key === 'id') {
            const idA = parseInt(a.id || 0);
            const idB = parseInt(b.id || 0);
            return (idA - idB) * direction;
        }

        // Tri par Domaine
        if (sortConfig.key === 'domaine_titre') {
            const dA = (a.domaine_titre || '').toLowerCase();
            const dB = (b.domaine_titre || '').toLowerCase();
            if (dA < dB) return -1 * direction;
            if (dA > dB) return 1 * direction;
            return 0;
        }

        // Tri par Processus
        if (sortConfig.key === 'processus_titre') {
            const pA = (a.processus_titre || '').toLowerCase();
            const pB = (b.processus_titre || '').toLowerCase();
            if (pA < pB) return -1 * direction;
            if (pA > pB) return 1 * direction;
            return 0;
        }

        // Tri par Type examen
        if (sortConfig.key === 'type_examen') {
            const tA = (a.type_examen || '').toLowerCase();
            const tB = (b.type_examen || '').toLowerCase();
            if (tA < tB) return -1 * direction;
            if (tA > tB) return 1 * direction;
            return 0;
        }

        // Tri par Niveau
        if (sortConfig.key === 'niveau') {
            const nA = parseInt(a.niveau || 0);
            const nB = parseInt(b.niveau || 0);
            return (nA - nB) * direction;
        }

        // Tri par Nbre heures
        if (sortConfig.key === 'nbre_heures') {
            const hA = parseInt(a.nbre_heures || 0);
            const hB = parseInt(b.nbre_heures || 0);
            return (hA - hB) * direction;
        }

        // Tri par Motif
        if (sortConfig.key === 'motif') {
            const mA = (a.motif || '').toLowerCase();
            const mB = (b.motif || '').toLowerCase();
            if (mA < mB) return -1 * direction;
            if (mA > mB) return 1 * direction;
            return 0;
        }

        return 0;
    });

    // Pagination
    const totalItems = sortedData.length;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const toggleColumnVisibility = (column) => {
        setVisibleColumns(prev => ({
            ...prev,
            [column]: !prev[column]
        }));
    };

    // Vérification des accès
    const [accesGroupe, setAccesGroupe] = useState([]);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();
                        setAccesGroupe(cleanedAccessArray);
                    }
                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Simulation") && !accesGroupe.includes("ExamenBlanc")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <BsStopwatch size={25} className='mr-2' />
                                Simulateur
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-complet`}> Simulateur </Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type} row justify-content-between position-relative m-3`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}


                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">

                            {/* Blocs de sélection des spécialités */}
                            {/* Blocs de sélection des spécialités */}
                            {isLoadingUserSpecialites ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-success" role="status">
                                        <span className="visually-hidden"></span>
                                    </div>
                                    <p className="mt-2 text-muted"></p>
                                </div>
                            ) : userSpecialites.length === 0 ? (
                                <div className="alert alert-warning">
                                    <i className="fa fa-exclamation-triangle mr-2"></i>
                                    Aucune spécialité n'est associée à votre compte. Veuillez contacter un administrateur.
                                </div>
                            ) : (
                                <div className="specialite-tabs mb-3">
                                    {userSpecialites.map((spec) => (
                                        <button
                                            key={spec.id}
                                            type="button"
                                            onClick={() => {
                                                setActiveSpecialite(spec);
                                                setCurrentPage(1);
                                            }}
                                            className={`specialite-tab ${isActiveSpecialite(spec) ? 'active' : ''}`}
                                        >
                                            {isActiveSpecialite(spec) && (
                                                <i className="fa fa-check mr-2"></i>
                                            )}
                                            {spec.titre}
                                        </button>
                                    ))}
                                </div>
                            )}

                            {/* Boutons d'action principaux */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>
                                    Historique complet
                                    {activeSpecialite && (
                                        <span className="text-muted ml-2">— {activeSpecialite.titre}</span>
                                    )}
                                </h5>
                                <div className="d-flex">

                                    {isLoadingPrincipe ? (
                                        <button className="btn btn-success mr-2" disabled>
                                            <i className="fa fa-spinner fa-spin mr-1"></i>
                                            <span className="d-none d-sm-inline ml-2">
                                                Chargement...
                                            </span>
                                        </button>
                                    ) : (
                                        <button className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                            onClick={() => handleChargerPrincipe()}>
                                            <FaQuestionCircle />
                                            <span className="d-none d-sm-inline ml-2">Mindset QCM</span>
                                        </button>
                                    )}

                                    {/* Nouvelle simulation - disponible pour toutes les spécialités */}
                                    <button className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                        onClick={() => setShowSimulationModal(true)}>
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">Nouvelle simulation</span>
                                    </button>

                                    <button className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                        onClick={() => {
                                            setNewExamenblanc({
                                                date_examen: '', heure_examen: '', type_examen: '', langue: '',
                                                nbre_heures: '', non_traite: false, tag: ''
                                            });
                                            setShowExamenModal(true);
                                        }}>
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">Réserver Examen</span>
                                    </button>

                                    <button className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                        onClick={() => {
                                            setNewExamenblanc({
                                                type_examen: 'Essai', langue: 'Fr', non_traite: false,
                                                code_essai: '', plage_debut: '', plage_fin: ''
                                            });
                                            setShowEssaiModal(true);
                                        }}>
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">Nouvel essai</span>
                                    </button>

                                    <Link to={`/Favoris`} className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1">
                                        <FaHeart />
                                        <span className="d-none d-sm-inline ml-2">
                                            Favoris
                                        </span>
                                    </Link>

                                    <Dropdown className="ms-2">
                                        <Dropdown.Toggle className="btn btn-success d-flex align-items-center justify-content-center ms-2 mt-1">
                                            <FaEye className="mr-1" />
                                            <span className="d-none d-sm-inline">
                                                Visibilité
                                            </span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {Object.entries(visibleColumns).map(([column, isVisible]) => (
                                                <Dropdown.Item
                                                    key={column}
                                                    onClick={() => toggleColumnVisibility(column)}
                                                    className="d-flex justify-content-between align-items-center"
                                                >
                                                    <span>
                                                        {column === 'date_unifiee' && 'Date'}
                                                        {column === 'specialite' && 'Spécialité'}
                                                        {column === 'domaine_titre' && 'Domaine'}
                                                        {column === 'processus_titre' && 'Processus'}
                                                        {column === 'qcmNumber' && 'Nbre Questions'}
                                                        {column === 'langue' && 'Langue'}
                                                        {column === 'niveau' && 'Niveau'}
                                                        {column === 'resultat' && 'Résultat'}
                                                        {column === 'tags' && 'Tags'}
                                                        {column === 'ref' && 'Référence'}
                                                        {column === 'type_examen' && 'Type Examen'}
                                                        {column === 'nbre_heures' && 'Heures'}
                                                        {column === 'statut' && 'Statut'}
                                                        {column === 'motif' && 'Motif'}
                                                    </span>
                                                    {isVisible && <FaCheck size={12} />}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>

                            {/* Modals */}

                            {/* Modal Nouvelle Simulation */}
                            <Modal show={showSimulationModal} onHide={() => setShowSimulationModal(false)}>
                                <Modal.Header><Modal.Title>Nouvelle simulation</Modal.Title></Modal.Header>

                                {alertModal.message && (
                                    <div className={`alert alert-${alertModal.type} row justify-content-between position-relative m-3`}>
                                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                                        <span
                                            onClick={fermerNotif}
                                            style={{
                                                position: 'absolute',
                                                top: '0px',
                                                right: '10px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <i className='fa fa-close'></i>
                                        </span>
                                    </div>
                                )}

                                <Modal.Body>
                                    <Form>
                                        {/* Domaine filtré par spécialité */}
                                        <Form.Group controlId="formDomaine">
                                            <Form.Label>Domaine de connaissance</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="domaine"
                                                value={newSimulation.domaine}
                                                onChange={handleNewSimulationChange}
                                                required
                                            >
                                                <option value="">Sélectionnez le domaine</option>
                                                {getDomainesForActiveSpecialite().map((domaine) => (
                                                    <option key={domaine.id} value={domaine.ordre}>
                                                        {domaine.titre}
                                                    </option>
                                                ))}
                                                <option value="0">Tout</option>
                                            </Form.Control>
                                            {getDomainesForActiveSpecialite().length === 0 && (
                                                <small className="text-danger">
                                                    Aucun domaine associé à cette spécialité. Veuillez contacter un administrateur.
                                                </small>
                                            )}
                                        </Form.Group>

                                        {/* Groupe de processus - MASQUÉ pour PMI-CP */}
                                        {!isActivePMICPNoProcessus() && (
                                            <Form.Group controlId="formProcessus" className="mt-3">
                                                <Form.Label>Groupe de processus</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="processus"
                                                    value={newSimulation.processus}
                                                    onChange={handleNewSimulationChange}
                                                    required
                                                >
                                                    <option value="">Sélectionnez le groupe</option>
                                                    {groupeProcessusFr.map((groupe_processus) => (
                                                        <option key={groupe_processus.id} value={groupe_processus.ordre}>
                                                            {groupe_processus.titre_fr}
                                                        </option>
                                                    ))}
                                                    <option value="0">Tout</option>
                                                </Form.Control>
                                            </Form.Group>
                                        )}

                                        <Form.Group controlId="formNiveau" className="mt-3">
                                            <Form.Label>Niveau de difficulté</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="niveau"
                                                value={newSimulation.niveau}
                                                onChange={handleNewSimulationChange}
                                                required
                                            >
                                                <option value="">Sélectionnez le niveau</option>
                                                <option value="1">Niveau 1</option>
                                                <option value="2">Niveau 2</option>
                                                <option value="0">Tout</option>
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group controlId="formNombreQCM" className="mt-3">
                                            <Form.Label>Nombre de QCM à simuler</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                name="qcmNumber"
                                                value={newSimulation.qcmNumber}
                                                onChange={handleNewSimulationChange}
                                                placeholder="Entrer le nombre de QCM"
                                                required
                                            />
                                        </Form.Group>

                                        <Form.Group controlId="formLangue" className="mt-3">
                                            <Form.Label>Langue</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="langue"
                                                value={newSimulation.langue}
                                                onChange={handleNewSimulationChange}
                                                required
                                            >
                                                <option value="">Sélectionnez la langue</option>
                                                <option value="Fr">Francais</option>
                                                <option value="Ang">Anglais</option>
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group controlId="formNonTraite" className="mt-3">
                                            <Form.Check
                                                type="checkbox"
                                                label="Afficher seulement les QCM non traités"
                                                name="nonTraite"
                                                checked={newSimulation.nonTraite}
                                                onChange={handleNewSimulationChange}
                                            />
                                        </Form.Group>

                                        <Form.Group controlId="formAleatoire" className="mt-3">
                                            <Form.Check
                                                type="checkbox"
                                                label="Afficher en aléatoire"
                                                name="aleatoire"
                                                checked={newSimulation.aleatoire}
                                                onChange={handleNewSimulationChange}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="default" onClick={() => setShowSimulationModal(false)}>Fermer</Button>
                                    <Button variant="success" onClick={handleSubmitNewSimulation}>
                                        {isLoadingEnreg ? 'Chargement..' : 'Enregistrer'}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Modal Réserver Examen */}
                            <Modal show={showExamenModal} onHide={() => setShowExamenModal(false)}>
                                <Modal.Header><Modal.Title>Réserver un Examen blanc</Modal.Title></Modal.Header>

                                {alertModal.message && (
                                    <div className={`alert alert-${alertModal.type} row justify-content-between position-relative m-3`}>
                                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                                        <span
                                            onClick={fermerNotif}
                                            style={{
                                                position: 'absolute',
                                                top: '0px',
                                                right: '10px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <i className='fa fa-close'></i>
                                        </span>
                                    </div>
                                )}

                                <Modal.Body>
                                    <Form>
                                        <Form.Group controlId="formTimezone" className="">
                                            <Form.Label>Fuseau horaire</Form.Label>
                                            <Form.Control as="select" name="timezone"
                                                value={newExamenblanc.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone}
                                                onChange={handleNewExamenblancChange} required>
                                                {timezones.map((tz) => (
                                                    <option key={tz.tzCode} value={tz.tzCode}>{tz.label} ({tz.tzCode})</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group controlId="formDateExamenblanc" className="mt-3">
                                            <Form.Label>Date de l'examen</Form.Label>
                                            <Form.Control type="date" name="date_examen" value={newExamenblanc.date_examen}
                                                onChange={handleNewExamenblancChange} min={new Date().toISOString().split("T")[0]} required />
                                        </Form.Group>

                                        <Form.Group controlId="formHeureExamenblanc" className="mt-3">
                                            <Form.Label>Heure de l'examen</Form.Label>
                                            <Form.Control type="time" name="heure_examen" value={newExamenblanc.heure_examen}
                                                onChange={handleNewExamenblancChange} required />
                                        </Form.Group>

                                        {/* Types d'examen dynamiques selon la spécialité active */}
                                        <Form.Group controlId="typeExamenblanc" className="mt-3">
                                            <Form.Label>Type d'examen</Form.Label>
                                            <Form.Control as="select" name="type_examen" value={newExamenblanc.type_examen}
                                                onChange={handleNewExamenblancChange} required>
                                                <option value="">Sélectionnez le type</option>
                                                {getAvailableExamTypes().map(type => (
                                                    <option key={type} value={type}>{type}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>

                                        {newExamenblanc.type_examen === 'Bootcamp' && (
                                            <Form.Group controlId="formTag" className="mt-3">
                                                <Form.Label>Tag</Form.Label>
                                                <Form.Control type="text" name="tag" placeholder="Entrez le tag du bootcamp"
                                                    value={newExamenblanc.tag || ''} onChange={handleNewExamenblancChange} required />
                                            </Form.Group>
                                        )}

                                        <Form.Group controlId="langueExamenblanc" className="mt-3">
                                            <Form.Label>Langue</Form.Label>
                                            <Form.Control as="select" name="langue" value={newExamenblanc.langue}
                                                onChange={handleNewExamenblancChange} required disabled={newExamenblanc.type_examen === 'Bootcamp'}>
                                                <option value="">Sélectionnez la langue</option>
                                                <option value="Fr">Français</option>
                                                <option value="Ang">Anglais</option>
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group controlId="formNbreHeures" className="mt-3">
                                            <Form.Label>Nombres d'heures</Form.Label>
                                            <Form.Control as="select" name="nbre_heures" value={newExamenblanc.nbre_heures}
                                                onChange={handleNewExamenblancChange} required disabled={newExamenblanc.type_examen === 'Bootcamp'}>
                                                <option value="">Sélectionnez le nombre d'heures</option>
                                                <option value="1">1 Heure (50 QCMs)</option>
                                                {newExamenblanc.type_examen !== 'Bootcamp' && (
                                                    <>
                                                        <option value="3">3 Heures (150 QCMs)</option>
                                                        <option value="4">4 Heures (200 QCMs)</option>
                                                    </>
                                                )}
                                            </Form.Control>
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="default" onClick={() => setShowExamenModal(false)}>Fermer</Button>
                                    <Button variant="success" onClick={handleSubmitNewExamenblanc} disabled={isButtonLoading}>
                                        {isButtonLoading ? 'Chargement...' : 'Enregistrer'}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Modal Réserver Essai */}
                            <Modal show={showEssaiModal} onHide={() => setShowEssaiModal(false)}>
                                <Modal.Header><Modal.Title>Réserver un essai</Modal.Title></Modal.Header>

                                {alertModal.message && (
                                    <div className={`alert alert-${alertModal.type} row justify-content-between position-relative m-3`}>
                                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                                        <span
                                            onClick={fermerNotif}
                                            style={{
                                                position: 'absolute',
                                                top: '0px',
                                                right: '10px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <i className='fa fa-close'></i>
                                        </span>
                                    </div>
                                )}

                                <Modal.Body>
                                    <Form>
                                        <Form.Group controlId="formCodeEssai" className="mt-1">
                                            <Form.Label>Code de l'essai</Form.Label>
                                            <Form.Control type="text" name="code_essai" placeholder=""
                                                value={newExamenblanc.code_essai || ''} onChange={handleNewExamenblancChange} required />
                                        </Form.Group>

                                        <Form.Group controlId="langueEssai" className="mt-3">
                                            <Form.Label>Langue</Form.Label>
                                            <Form.Control as="select" name="langue" value={newExamenblanc.langue}
                                                onChange={handleNewExamenblancChange} required>
                                                <option value="">Sélectionnez la langue</option>
                                                <option value="Fr">Français</option>
                                                <option value="Ang">Anglais</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="default" onClick={() => setShowEssaiModal(false)}>Fermer</Button>
                                    <Button variant="success" onClick={handleSubmitEssai} disabled={isButtonLoading}>
                                        {isButtonLoading ? 'Chargement...' : 'Enregistrer'}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Modal de modification d'examen */}
                            <Modal show={showModifierModal} onHide={() => setShowModifierModal(false)}>
                                <Modal.Header>
                                    <Modal.Title>Modifier Examen blanc</Modal.Title>
                                </Modal.Header>

                                {alertModal.message && (
                                    <div className={`alert alert-${alertModal.type} row justify-content-between position-relative m-3`}>
                                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                                        <span
                                            onClick={fermerNotif}
                                            style={{
                                                position: 'absolute',
                                                top: '0px',
                                                right: '10px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <i className='fa fa-close'></i>
                                        </span>
                                    </div>
                                )}

                                <Modal.Body>
                                    <Form>
                                        <Form.Group controlId="formTimezone" className="">
                                            <Form.Label>Fuseau horaire</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="timezone"
                                                value={examenblancDetails.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone}
                                                onChange={(e) => setExamenblancDetails({ ...examenblancDetails, timezone: e.target.value })}
                                                required
                                            >
                                                {timezones.map((tz) => (
                                                    <option key={tz.tzCode} value={tz.tzCode}>
                                                        {tz.label} ({tz.tzCode})
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group controlId="formDateExamenblanc" className="mt-3">
                                            <Form.Label>Date de l'examen</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="date_examen"
                                                value={examenblancDetails.date_examen}
                                                onChange={(e) => setExamenblancDetails({ ...examenblancDetails, date_examen: e.target.value })}
                                                min={new Date().toISOString().split("T")[0]}
                                                required
                                            />
                                        </Form.Group>

                                        <Form.Group controlId="formHeureExamenblanc" className="mt-3">
                                            <Form.Label>Heure de l'examen</Form.Label>
                                            <Form.Control
                                                type="time"
                                                name="heure_examen"
                                                value={examenblancDetails.heure_examen}
                                                onChange={(e) => setExamenblancDetails({ ...examenblancDetails, heure_examen: e.target.value })}
                                                required
                                            />
                                        </Form.Group>

                                        {/* Types d'examen dynamiques */}
                                        <Form.Group controlId="typeExamenblanc" className="mt-3">
                                            <Form.Label>Type d'examen</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="type_examen"
                                                value={examenblancDetails.type_examen}
                                                onChange={(e) => setExamenblancDetails({ ...examenblancDetails, type_examen: e.target.value })}
                                                required
                                            >
                                                <option value="">Sélectionnez le type</option>
                                                {getAvailableExamTypes().map(type => (
                                                    <option key={type} value={type}>{type}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group controlId="langueExamenblanc" className="mt-3">
                                            <Form.Label>Langue</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="langue"
                                                value={examenblancDetails.langue || ''}
                                                required
                                                onChange={(e) => setExamenblancDetails({ ...examenblancDetails, langue: e.target.value })}
                                            >
                                                <option value="">Sélectionnez la langue</option>
                                                <option value="Fr">Francais</option>
                                                <option value="Ang">Anglais</option>
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group controlId="formNbreHeures" className="mt-3">
                                            <Form.Label>Nombres d'heures</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="nbre_heures"
                                                value={examenblancDetails.nbre_heures || ''}
                                                required
                                                onChange={(e) => setExamenblancDetails({ ...examenblancDetails, nbre_heures: e.target.value })}
                                            >
                                                <option value="">Sélectionnez le nombre d'heures</option>
                                                <option value="1">1 Heure (50 QCMs)</option>
                                                <option value="3">3 Heures (150 QCMs)</option>
                                                <option value="4">4 Heures (200 QCMs)</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="default" onClick={() => setShowModifierModal(false)}>
                                        Fermer
                                    </Button>
                                    {isButtonLoading ? (
                                        <button className="btn btn-success mr-2" disabled>
                                            <i className="fa fa-spinner fa-spin mr-1"></i>
                                            <span className="d-none d-sm-inline ml-2">
                                                Chargement...
                                            </span>
                                        </button>
                                    ) : (
                                        <Button variant="success" onClick={handleModifierExamen}>
                                            Modifier
                                        </Button>
                                    )}
                                </Modal.Footer>
                            </Modal>

                            {/* Modal Démarrage Examen */}
                            <Modal show={showDemarageModal} onHide={() => setShowDemarageModal(false)}>
                                <Modal.Header><Modal.Title>Informations Importantes</Modal.Title></Modal.Header>
                                <Modal.Body>
                                    {selectedItem?.type_examen === 'Essai' ? (
                                        <div>
                                            <p><strong>Essai en mode démonstration</strong></p>
                                            <p>Cet essai vous permet de vous familiariser avec l'interface d'examen sans contrainte de temps.</p>
                                            <ul>
                                                <li>Navigation libre entre les questions</li>
                                                <li>Aucune limite de temps</li>
                                                <li>Résultats disponibles immédiatement</li>
                                            </ul>
                                        </div>
                                    ) : (
                                        <div>
                                            <p>Cher apprenant, avant de commencer votre examen, voici quelques informations essentielles à retenir :</p>
                                            <ul>
                                                <li><strong>Connexion Internet :</strong> Assurez-vous d'avoir une connexion internet stable et de bonne qualité pour éviter toute interruption.</li>
                                                <li><strong>Durée de l'examen :</strong> Votre examen durera <strong>{selectedItem?.nbre_heures} heure(s)</strong>. Toutes les <strong>{(selectedItem?.nbre_heures * 60) / 3} minutes</strong>, vous aurez la possibilité de prendre une pause de <strong>10 minutes</strong>.</li>
                                                <li><strong>Pendant la pause :</strong> Vous ne pourrez pas naviguer entre les questions, mais vous aurez accès au récapitulatif de vos réponses.</li>
                                            </ul>
                                            <p><strong>Option de pause :</strong> Souhaitez-vous passer votre examen avec ou sans pause ? La pause n'est pas obligatoire.</p>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="pauseOption" id="avecPause"
                                                    value="avecPause" checked={pauseChoice === "avecPause"} onChange={() => setPauseChoice("avecPause")} />
                                                <label className="form-check-label" htmlFor="avecPause">Avec pause (recommandé)</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="pauseOption" id="sansPause"
                                                    value="sansPause" checked={pauseChoice === "sansPause"} onChange={() => setPauseChoice("sansPause")} />
                                                <label className="form-check-label" htmlFor="sansPause">Sans pause</label>
                                            </div>
                                            <p className="mt-3"><strong>Note :</strong> Les temps de pause seront déduits de votre temps réglementaire (<strong>{selectedItem?.nbre_heures} heure(s)</strong>).</p>
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-secondary" onClick={() => setShowDemarageModal(false)}>Annuler</button>
                                    <button className="btn btn-success" onClick={() => handleDemarrerExamen(selectedItem)}>
                                        {selectedItem?.type_examen === 'Essai' ? 'Commencer l\'essai' : 'Commencer l\'examen'}
                                    </button>
                                </Modal.Footer>
                            </Modal>


                            {/* Tableau unifié */}
                            <div className="row">
                                <div className="col-lg-12 pr-0 pl-0">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select value={itemsPerPage} onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1" style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}>
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input type="text" placeholder="Rechercher..." className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }} value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)} />
                                            </div>

                                            <div style={{ fontSize: '11px', overflowX: 'auto' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-secondary" onClick={() => handleSort('type')} style={{ cursor: 'pointer' }}>
                                                                Type {sortConfig.key === 'type' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            {visibleColumns.specialite && (
                                                                <th className="text-secondary d-none d-md-table-cell" onClick={() => handleSort('specialite_titre')} style={{ cursor: 'pointer' }}>
                                                                    Spécialité {sortConfig.key === 'specialite_titre' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                </th>
                                                            )}
                                                            {visibleColumns.date_unifiee && <th className="text-secondary d-none d-md-table-cell" onClick={() => handleSort('date_unifiee')} style={{ cursor: 'pointer' }}>
                                                                Date {sortConfig.key === 'date_unifiee' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.ref && <th className='text-secondary text-center' onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>
                                                                Ref {sortConfig.key === 'id' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.domaine_titre && <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('domaine_titre')} style={{ cursor: 'pointer' }}>
                                                                Domaine {sortConfig.key === 'domaine_titre' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.processus_titre && <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('processus_titre')} style={{ cursor: 'pointer' }}>
                                                                Processus {sortConfig.key === 'processus_titre' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.qcmNumber && <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('qcmNumber')} style={{ cursor: 'pointer' }}>
                                                                Nbre questions {sortConfig.key === 'qcmNumber' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.type_examen && <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('type_examen')} style={{ cursor: 'pointer' }}>
                                                                Type {sortConfig.key === 'type_examen' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.langue && <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('langue')} style={{ cursor: 'pointer' }}>
                                                                Langue {sortConfig.key === 'langue' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.niveau && <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('niveau')} style={{ cursor: 'pointer' }}>
                                                                Niveau {sortConfig.key === 'niveau' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.nbre_heures && <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('nbre_heures')} style={{ cursor: 'pointer' }}>
                                                                Heures {sortConfig.key === 'nbre_heures' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.resultat && <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('resultat')} style={{ cursor: 'pointer' }}>
                                                                Résultat {sortConfig.key === 'resultat' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.statut && <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('statut')} style={{ cursor: 'pointer' }}>
                                                                Statut {sortConfig.key === 'statut' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.motif && <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('motif')} style={{ cursor: 'pointer' }}>
                                                                Motif {sortConfig.key === 'motif' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            {visibleColumns.tags && <th className="text-secondary d-none text-center d-md-table-cell" onClick={() => handleSort('tags')} style={{ cursor: 'pointer' }}>
                                                                Tags {sortConfig.key === 'tags' && (sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>}
                                                            <th className="text-secondary text-center">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!isLoading ? (
                                                            currentItems.length > 0 ? (
                                                                currentItems.map((item) => (
                                                                    <tr key={`${item.type}-${item.id}`}
                                                                        className={`bg-white ${selectedItem?.id === item.id && selectedItem?.type === item.type ? 'bg-success text-white' : ''}`}>

                                                                        <td>
                                                                            <span className={`badge ${item.type === 'simulation'
                                                                                ? 'bg-primary'
                                                                                : item.type_examen === 'Essai'
                                                                                    ? 'bg-info'
                                                                                    : 'bg-warning'
                                                                                }`}>
                                                                                {
                                                                                    item.type === 'simulation'
                                                                                        ? 'Simulation'
                                                                                        : item.type_examen === 'Essai'
                                                                                            ? 'Essai'
                                                                                            : 'Examen'
                                                                                }
                                                                            </span>
                                                                        </td>
                                                                        {visibleColumns.specialite && (
                                                                            <td className="d-none d-md-table-cell ">
                                                                                {item.specialite_titre ? (
                                                                                    <span className="badge bg-light text-dark border" style={{ fontSize: '10px' }}>
                                                                                        {item.specialite_titre}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="text-dark " style={{ fontSize: '10px' }}>
                                                                                        Aucune
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                        )}
                                                                        {visibleColumns.date_unifiee && (
                                                                            <td className="d-none d-md-table-cell">
                                                                                {formatValue(item.date_unifiee)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.ref && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {formatValue(item.id)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.domaine_titre && (
                                                                            <td className="d-none text-center d-md-table-cell">
                                                                                {formatValue(item.domaine_titre)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.processus_titre && (
                                                                            <td className="d-none text-center d-md-table-cell">
                                                                                {formatValue(item.processus_titre)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.qcmNumber && (
                                                                            <td className="d-none text-center d-md-table-cell">
                                                                                {item.type === 'examen' ? (
                                                                                    (() => {
                                                                                        const heures = parseInt(item.nbre_heures);
                                                                                        if (heures === 0) return item.total_questions;
                                                                                        if (heures === 1) return '50';
                                                                                        if (heures === 3) return '150';
                                                                                        if (heures === 4) return '200';
                                                                                        return formatValue(item.nbre_heures);
                                                                                    })()
                                                                                ) : (
                                                                                    formatValue(item.qcmNumber)
                                                                                )}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.type_examen && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {formatValue(item.type_examen)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.langue && (
                                                                            <td className="d-none text-center d-md-table-cell">
                                                                                {formatValue(item.langue)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.niveau && (
                                                                            <td className="d-none text-center d-md-table-cell">
                                                                                {formatValue(item.niveau)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.nbre_heures && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {formatValue(item.nbre_heures)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.resultat && (
                                                                            <td className="d-none text-center d-md-table-cell"
                                                                                style={{
                                                                                    color: item.type === 'examen' && item.pourcent ?
                                                                                        (Number(item.pourcent) < 80 ? 'red' : 'green') : 'inherit'
                                                                                }}>
                                                                                {item.resultat}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.statut && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {item.statut === "Approuve" && "Approuvé"}
                                                                                {item.statut === "Rejete" && "Rejeté"}
                                                                                {item.statut === "Termine" && "Terminé"}
                                                                                {item.statut === "En cours de validation" && "En cours de validation"}
                                                                                {!item.statut && "-"}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.motif && (
                                                                            <td className="d-none d-md-table-cell text-center">
                                                                                {formatValue(item.motif)}
                                                                            </td>
                                                                        )}

                                                                        {visibleColumns.tags && (
                                                                            <td className="d-none text-center d-md-table-cell">
                                                                                {formatValue(item.tags || item.tag)}
                                                                            </td>
                                                                        )}

                                                                        <td className="text-center">
                                                                            <Dropdown>
                                                                                <Dropdown.Toggle
                                                                                    variant="outline-"
                                                                                    size="sm"
                                                                                    id={`dropdown-${item.type}-${item.id}`}
                                                                                >
                                                                                    <FaEllipsisV />
                                                                                </Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    {item.type === 'simulation' ? (
                                                                                        <>
                                                                                            <Dropdown.Item onClick={() => handleDemarrerSimulation(item)}>
                                                                                                <FaPlay className="mr-2" /> {item.pourcentage !== "" ? 'Recommencer' : 'Démarrer'}
                                                                                            </Dropdown.Item>

                                                                                            {(item.statut === "Termine" || item.pourcentage !== "") && (
                                                                                                <Dropdown.Item onClick={() => handleResultatSimulateur(item.id)}>
                                                                                                    <FaNewspaper className="mr-2" /> Résultats
                                                                                                </Dropdown.Item>
                                                                                            )}
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            {item.statut === "En cours de validation" && item.type_examen !== "Essai" && (
                                                                                                <Dropdown.Item onClick={() => handleShowModifierModal(item)}>
                                                                                                    <FaEdit className="mr-2" /> Modifier
                                                                                                </Dropdown.Item>
                                                                                            )}
                                                                                            {item.statut === "Approuve" && (
                                                                                                <Dropdown.Item onClick={() => {
                                                                                                    setSelectedItem(item);
                                                                                                    setShowDemarageModal(true);
                                                                                                }}>
                                                                                                    <FaPlay className="mr-2" />
                                                                                                    {examen_id_strored && item.id === examen_id_strored && stored ? 'Continuer' : 'Démarrer'}
                                                                                                </Dropdown.Item>
                                                                                            )}
                                                                                            {item.statut === "Termine" && (
                                                                                                <Dropdown.Item onClick={() => handleResultatExamen(item.id)}>
                                                                                                    <FaNewspaper className="mr-2" /> Résultats
                                                                                                </Dropdown.Item>
                                                                                            )}
                                                                                            {item.type_examen === "Essai" && item.statut === "Termine" && (
                                                                                                <Dropdown.Item onClick={() => {
                                                                                                    setSelectedItem(item);
                                                                                                    setShowDemarageModal(true);
                                                                                                }}>
                                                                                                    <FaPlay className="mr-2" /> Recommencer
                                                                                                </Dropdown.Item>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={Object.values(visibleColumns).filter(Boolean).length + 2} className="text-center py-4">
                                                                        <div className="text-muted">
                                                                            <i className="fa fa-inbox" style={{ fontSize: '40px' }}></i>
                                                                            <p className="mt-2">
                                                                                Aucune donnée disponible pour la spécialité
                                                                                {activeSpecialite && ` "${activeSpecialite.titre}"`}
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={Object.values(visibleColumns).filter(Boolean).length + 2} className="text-center">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0 ? "Aucun élément à afficher" :
                                                        `Élément ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1" disabled={currentPage === 1}>
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }
                                                        const pageButtons = [];
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button key={i} onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}>
                                                                    {i}
                                                                </button>
                                                            );
                                                        }
                                                        return pageButtons;
                                                    })()}

                                                    <button onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1" disabled={currentPage === totalPages}>
                                                        <FaArrowRight />
                                                    </button>

                                                    <button onClick={() => setCurrentPage(totalPages)} className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}>{totalPages}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Historique_unifie;